import {Component, Input, OnInit} from "@angular/core";
import {Product} from "../product";
import {Website} from "../website";
import {DbResponse} from "../../../shared/interceptors/db-response";
import {NotifierComponent} from "../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../shared/components/notifier/notification";
import {NotificationType} from "../../../shared/components/notifier/notification-type";
import {DialogComponent} from "../../../../ng2-bootstrap-modal/dialog.component";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";
import {ProductService} from '../product.service';
import {ActivityAction} from '../../../activities/activity';
import * as fromStore from '../../../store';
import {DbStoreState} from '../../../store/reducers';
import {Store} from '@ngrx/store';
import {filter, first} from "rxjs/operators";

export interface IChangelogData {
  website: Website;
  product: Product;
  isManagable: boolean;
}
@Component({
    selector: 'db-changelog',
    templateUrl: './changelog.component.html',
    styleUrls: ['./changelog.component.scss'],
    standalone: false
})
export class ChangelogComponent extends DialogComponent<IChangelogData, null> implements OnInit, IChangelogData {

  @Input() website: Website;
  @Input() product: Product;
  @Input() isManagable: boolean;

  public loading: boolean;

  public title: string;
  public changes: any;

  constructor(
    private _store: Store<DbStoreState>,
    private _dialogService: DialogService,
    private _productService: ProductService
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {
    this.title = `${this.product.title} changelog`;

    this.getChangelog();
  }

  private getChangelog(): void {
    this.loading = true;
    this._productService.getChangelog(this.product.productId)
      .pipe(filter((response: DbResponse): boolean => !!response),
        first())
      .subscribe((response: DbResponse): void => {
        this.loading = false;

        if (response.success) {
          this.setChanges(response.data);
        }
        else {
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
      });
  }

  private setChanges(chengelog): void {
      for (let i = 0; i < chengelog.length; i++) {
          chengelog[i].versionNumber = this.versionToNumber(chengelog[i].version);
      }
      this.changes = chengelog;
  }

  private versionToNumber(v: string): number {

      if (v.charAt(0) === 'v') {
          v = v.substr(1);
      }

      const version = v.split('.');
      let value = "";
      for (let i = 0; i < 3; i++) {
          if (version[i].length === 0) {
              value += "000";
          } else if (version[i].length === 1) {
              value += "00" + version[i];
          } else if (version[i].length === 2) {
              value += "0" + version[i];
          } else {
              value += version[i];
          }

      }
      return parseInt(value, 10);
  }

  public update(): void {
    this._store.dispatch(new fromStore.InitWebsiteProductAction({
      website: this.website,
      products: [this.product],
      action: ActivityAction.UPDATE,
      network: 1
    }));
    this.close();
  }

}
